const searchableList = (): void => {
  const selectors = {
    searchableList: '[data-searchable-list]',
    searchableListInput: '[data-searchable-list-input]',
    searchablelistGroup: '[data-searchable-list-group]',
    searchablelistGroupAttr: 'data-searchable-list-group',
    searchablelistItem: '[data-searchable-list-item]',
    searchablelistItemAttr: 'data-searchable-list-item',
    itemHeading: '[data-item-heading]',
    itemContent: '[data-item-content]',
  };

  const classes = {
    searchablelistItemOpen: 'list__item--open',
  };

  const searchableListSections = document.querySelectorAll(
    selectors.searchableList
  );

  const openAccordion = (
    accordion: HTMLElement,
    accordionContent: HTMLElement
  ): void => {
    accordion.classList.add(classes.searchablelistItemOpen);
    accordionContent.style.maxHeight = accordionContent.scrollHeight + 'px';
  };

  const closeAccordion = (
    accordion: HTMLElement,
    accordionContent: HTMLElement
  ): void => {
    accordion.classList.remove(classes.searchablelistItemOpen);
    accordionContent.style.maxHeight = null as any;
  };

  searchableListSections.forEach((section) => {
    const searchListInput = section.querySelector<HTMLInputElement>(
      selectors.searchableListInput
    );

    const listGroups = section.querySelectorAll<HTMLElement>(
      selectors.searchablelistGroup
    );

    const listItems = section.querySelectorAll<HTMLElement>(
      selectors.searchablelistItem
    );

    const searchList = (value: string): void => {
      listGroups.forEach((group) => {
        let itemsVisibleInGroup = false;
        const groupID = group.getAttribute(selectors.searchablelistGroupAttr);
        const listItems = group.querySelectorAll('li');
        const filter = value.toUpperCase();
        const link = section.querySelector(
          `.filters__link[href="#${groupID}"]`
        );

        listItems.forEach((item) => {
          const heading = item
            .querySelector<HTMLElement>(selectors.itemHeading)
            ?.innerText.toUpperCase();

          if (heading && heading.indexOf(filter) > -1) {
            item.style.display = '';
            itemsVisibleInGroup = true;
          } else {
            item.style.display = 'none';
          }
        });

        if (link) {
          link.classList[itemsVisibleInGroup ? 'remove' : 'add'](
            'filters__link--hidden'
          );
        }

        group.classList[itemsVisibleInGroup ? 'remove' : 'add'](
          'searchable-list__group--hidden'
        );
      });
    };

    listItems.forEach((item) => {
      const itemID = item.getAttribute(selectors.searchablelistItemAttr);
      const itemButton = item.querySelector<HTMLElement>(selectors.itemHeading);
      const itemContent = item.querySelector<HTMLElement>(
        selectors.itemContent
      );

      if (itemButton && itemContent) {
        itemButton.addEventListener('click', () => {
          if (itemContent.style.maxHeight) {
            closeAccordion(item, itemContent);
          } else {
            listItems.forEach((otherItem) => {
              const otherItemContent: any =
                otherItem.querySelector<HTMLElement>(selectors.itemContent);
              closeAccordion(otherItem, otherItemContent);
            });
            openAccordion(item, itemContent);
          }
        });

        if (window.location.hash) {
          const windowLocationHash = window.location.hash.replace('#', '');

          if (itemID == windowLocationHash) {
            openAccordion(item, itemContent);
            history.pushState(
              '',
              document.title,
              window.location.pathname + window.location.search
            );
          }
        }
      }
    });

    if (searchListInput) {
      searchListInput.addEventListener('keyup', () => {
        const value: string = searchListInput.value;
        searchList(value);
      });
    }

    window.addEventListener('resize', () => {
      listItems.forEach((item: HTMLElement) => {
        const itemContent = item.querySelector<HTMLElement>(
          selectors.itemContent
        );
        if (itemContent && itemContent.style.maxHeight) {
          openAccordion(item, itemContent);
        }
      });
    });
  });
};

export default searchableList;
